export default __webpack_public_path__ + "static/media/darkSaas.79554ae5.svg";